export interface OiamErrorPayload {
  id: string;
  message: string;
  details?: any;
}
export function isOiamErrorPayload(payload: any) {
  if (typeof payload === 'object') {
    return 'id' in payload && 'message' in payload;
  }
  return false;
}

export const ERR_NOT_CONFIGURED: OiamErrorPayload = {
  id: 'OIAM-01',
  message: 'oiam-oauth-wc is not correctly configured',
};
export const ERR_INVALID_CONFIG: OiamErrorPayload = {
  id: 'OIAM-02',
  message: 'Invalid oiamSetConfigEvent',
};
export const ERR_NO_USER: OiamErrorPayload = {
  id: 'OIAM-03',
  message: 'No valid user token at token response',
};
export const ERR_NO_TOKEN: OiamErrorPayload = {
  id: 'OIAM-04',
  message: 'Error Token-Refresh',
};
export const ERR_OIAM_GENERAL: OiamErrorPayload = {
  id: 'OIAM-06',
  message: 'Error from OIAM',
};
export const ERR_OIAM_USER: OiamErrorPayload = {
  id: 'OIAM-07',
  message: 'User triggered error from OIAM',
};
export const ERR_LOGIN: OiamErrorPayload = {
  id: 'OIAM-08',
  message: 'Error Login',
};
export const ERR_RELOGIN: OiamErrorPayload = {
  id: 'OIAM-09',
  message: 'Error Relogin',
};
export const ERR_UNMET: OiamErrorPayload = {
  id: 'OIAM-10',
  message: 'Unmet requirements',
};
export const ERR_LOOP_DETECTED: OiamErrorPayload = {
  id: 'OIAM-11',
  message: 'Loop detected',
};

export const ERR_OIAM_MULTIPLE_INSTANCES: OiamErrorPayload = {
  id: 'OIAM-99',
  message: 'More than one oiam-oauth-wc instance loaded in page',
};

export class OiamErrorPayloadException extends Error {
  public readonly payload: OiamErrorPayload;

  public constructor(p: OiamErrorPayload) {
    super(p.message);
    this.payload = p;
  }

  public static extract(err?: Error): OiamErrorPayload | Error {
    if (err && err instanceof OiamErrorPayloadException) {
      return err.payload;
    } else {
      return err;
    }
  }
}
